import { css } from '@emotion/core';
import { rgba } from 'polished';
export const nested = (theme) => css `
  padding-left: ${theme.spacing(0.4)}rem;
`;
export const innerDrawer = css `
  width: inherit;
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const drawerOpen = (theme) => css `
  width: ${theme.typography.pxToRem(theme.mixins.sidebar.width.open)};
  ${theme.breakpoints.up('sm')} {
    width: ${theme.typography.pxToRem(theme.mixins.sidebar.width.open)};
  }
`;
export const drawerClose = (theme) => css `
  ${theme.breakpoints.up('sm')} {
    width: ${theme.typography.pxToRem(theme.mixins.sidebar.width.closed)};
  }
`;
export const divider = (theme) => css `
  background-color: ${rgba(theme.palette.secondary.light, 0.15)};
  border-bottom-color: ${theme.palette.secondary.light};
`;
export const drawer = (theme) => css `
  background-color: ${theme.palette.secondary.main};
  width: 0;
  height: 100%;
  white-space: nowrap;

  & .MuiDrawer-paper {
    width: inherit;
    background-color: inherit;
    border-right: none !important;
    position: relative;
  }

  ${theme.breakpoints.up('sm')} {
    width: 6rem;
  }
`;
export const hideVersion = css `
  opacity: 0;
`;
export const logoWrapper = (theme) => css `
  display: flex;
  justify-content: space-between;
  color: ${theme.palette.secondary.light};
`;
